import { BreakdownTypes } from '@wix/cashier-express-checkout-widget/dist/src/types/PaymentBreakdown';
import { round } from './math.utils';
import { checkIfItemHasDiscount, getDiscountsValue } from './discounts.utils';
import { getDeliveryAdditionalFees, getNonDeliveryAdditionalFees } from './deliveryAdditionalFee.utils';
export function getPaymentBreakdown(_ref, taxOnProduct, discountsToAlignWith, shouldMergeExpressDeliveryRateWithHandlingFee, shouldSupportTaxExemptionOnCheckout) {
  var _shippingInfo$selecte, _payNow$shipping, _payNow$tax;
  let {
    payNow,
    giftCard,
    lineItems,
    additionalFees,
    shippingInfo,
    taxSummary
  } = _ref;
  if (discountsToAlignWith === void 0) {
    discountsToAlignWith = [];
  }
  if (shouldMergeExpressDeliveryRateWithHandlingFee === void 0) {
    shouldMergeExpressDeliveryRateWithHandlingFee = true;
  }
  const itemsTotal = getItemsTotal(lineItems, discountsToAlignWith);
  const baseShippingTotal = taxOnProduct ? (shippingInfo == null || (_shippingInfo$selecte = shippingInfo.selectedCarrierServiceOption) == null || (_shippingInfo$selecte = _shippingInfo$selecte.cost) == null || (_shippingInfo$selecte = _shippingInfo$selecte.price) == null ? void 0 : _shippingInfo$selecte.amount) ?? '0' : (payNow == null || (_payNow$shipping = payNow.shipping) == null ? void 0 : _payNow$shipping.amount) ?? '0';
  const taxTotal = taxOnProduct ? '0' : (payNow == null || (_payNow$tax = payNow.tax) == null ? void 0 : _payNow$tax.amount) ?? '0';
  const totalDiscount = getTotalDiscount({
    discountsToAlignWith,
    taxSummary,
    shouldSupportTaxExemptionOnCheckout,
    taxOnProduct,
    payNow,
    giftCard
  });
  const feesTotal = getAdditionalFeesTotal(shouldMergeExpressDeliveryRateWithHandlingFee ? getNonDeliveryAdditionalFees(additionalFees) : additionalFees || []);
  const itemsTotalWithAdditionalFees = round(Number(itemsTotal) + feesTotal).toString();
  const shippingFeesTotal = shouldMergeExpressDeliveryRateWithHandlingFee ? getAdditionalFeesTotal(getDeliveryAdditionalFees(additionalFees)) : 0;
  const shippingTotal = round(Number(baseShippingTotal) + shippingFeesTotal).toString();
  return {
    [BreakdownTypes.ItemsTotal]: itemsTotalWithAdditionalFees,
    [BreakdownTypes.Shipping]: shippingTotal,
    [BreakdownTypes.Tax]: taxTotal,
    [BreakdownTypes.Discount]: totalDiscount
  };
}
function getItemsTotal(items, discountsToAlignWith) {
  if (discountsToAlignWith === void 0) {
    discountsToAlignWith = [];
  }
  const total = (items ?? []).reduce((acc, lineItem) => {
    var _lineItem$priceBefore;
    const {
      price: lineItemPrice,
      quantity
    } = lineItem;
    const amount = (lineItemPrice == null ? void 0 : lineItemPrice.amount) ?? '0';
    const priceBeforeDiscounts = ((_lineItem$priceBefore = lineItem.priceBeforeDiscounts) == null ? void 0 : _lineItem$priceBefore.amount) ?? '0';
    const price = checkIfItemHasDiscount(lineItem, discountsToAlignWith) ? priceBeforeDiscounts : amount;
    return acc + Number(price) * (quantity ?? 1);
  }, 0);
  return round(total).toString();
}
function getAdditionalFeesTotal(fees) {
  const total = (fees ?? []).reduce((acc, lineItem) => {
    const {
      price: lineItemPrice
    } = lineItem;
    const amount = (lineItemPrice == null ? void 0 : lineItemPrice.amount) ?? '0';
    const price = amount;
    return acc + Number(price);
  }, 0);
  return round(total);
}
function getTotalDiscount(_ref2) {
  var _payNow$discount, _giftCard$amount, _taxSummary$totalExem;
  let {
    discountsToAlignWith,
    taxSummary,
    shouldSupportTaxExemptionOnCheckout,
    taxOnProduct,
    payNow,
    giftCard
  } = _ref2;
  const payNowDiscount = (payNow == null || (_payNow$discount = payNow.discount) == null ? void 0 : _payNow$discount.amount) ?? '0';
  const lineItemDiscounts = getDiscountsValue(discountsToAlignWith);
  const discountTotal = Number(payNowDiscount) + lineItemDiscounts;
  const giftCardTotal = (giftCard == null || (_giftCard$amount = giftCard.amount) == null ? void 0 : _giftCard$amount.amount) ?? '0';
  const taxExemptTotal = shouldSupportTaxExemptionOnCheckout && taxOnProduct ? (taxSummary == null || (_taxSummary$totalExem = taxSummary.totalExempt) == null ? void 0 : _taxSummary$totalExem.amount) ?? '0' : '0';
  return round(Number(discountTotal) + Number(giftCardTotal) + Number(taxExemptTotal)).toString();
}
//# sourceMappingURL=getPaymentBreakdown.js.map